import React, { useEffect, useState } from 'react';
import businessAreaService from '../services/businessAreaService';

/**
 * Vorhaben auswählen — Liste der schon vergebenen Namen, mit der Möglichkeit, einen neuen zu
 * tippen.
 *
 * Freitext mit Vorschlagsliste statt einer festen Aufzählung: der nächste Bereich soll keine
 * Migration kosten. Die Liste ist dabei kein Komfort, sondern der Schutz vor dem eigentlichen
 * Problem eines Freitextfelds — „Radsport-Events" und „Radsport Events" wären zwei Vorhaben,
 * und beide hätten die halbe Wahrheit.
 *
 * Bewusst ein `<datalist>` und kein Auswahlfeld mit „Neu …"-Eintrag: der übliche Fall ist die
 * Auswahl eines vorhandenen Namens, der seltene das Anlegen — beides in einem Feld, ohne
 * Moduswechsel.
 */
interface Props {
  value: string | null | undefined;
  onChange: (value: string | null) => void;
  disabled?: boolean;
  id?: string;
  /** Vorgeladene Namen; sonst holt die Komponente sie selbst. */
  options?: string[];
}

const BusinessAreaPicker: React.FC<Props> = ({ value, onChange, disabled, id, options }) => {
  const [known, setKnown] = useState<string[]>(options ?? []);
  const listId = `${id ?? 'business-area'}-list`;

  useEffect(() => {
    if (options) { setKnown(options); return; }
    let cancelled = false;
    businessAreaService.list()
      .then(list => { if (!cancelled) setKnown(list); })
      .catch(() => { /* ohne Vorschläge bleibt das Feld ein normales Textfeld */ });
    return () => { cancelled = true; };
  }, [options]);

  return (
    <>
      <input
        id={id}
        list={listId}
        type="text"
        value={value ?? ''}
        disabled={disabled}
        placeholder="z. B. Radsport-Events"
        // Leer heißt „keinem Vorhaben zugeordnet" — das ist ein gültiger Zustand und der
        // Normalfall, nicht ein fehlender Wert.
        onChange={e => onChange(e.target.value.trim() === '' ? null : e.target.value)}
        className="w-full rounded px-3 py-2 text-sm"
        style={{
          background: 'var(--input-bg)',
          border: '1px solid var(--surface-border)',
          color: 'var(--text-primary)',
        }}
      />
      <datalist id={listId}>
        {known.map(area => <option key={area} value={area} />)}
      </datalist>
    </>
  );
};

export default BusinessAreaPicker;
